export default __webpack_public_path__ + "static/apple-store_download_us-0b167de200ef015149c04b10c8c3dba4.png";